'use client';

import type { ChangeEvent } from 'react';
import { forwardRef } from 'react';
import { TextField } from '@kcd/design-system';

type TextFieldProps = Omit<
  React.ComponentProps<typeof TextField>,
  'ref' | 'type' | 'value' | 'onChange'
>;

type Props = {
  onChange?: (value: string) => void;
  className?: string;
  value?: string;
} & TextFieldProps;

const MAX_LENGTH = 11;
const ALLOW_PATTERN = /^$|^0$|^01$|^01[016789]$|01[016789]\d{0,8}/;

function formatPhoneNumber(value: string) {
  const digits = value.replace(/\D/g, '').slice(0, MAX_LENGTH);
  if (digits.length <= 3) return digits;
  if (digits.length <= 7) return `${digits.slice(0, 3)} ${digits.slice(3)}`;
  return `${digits.slice(0, 3)} ${digits.slice(3, 7)} ${digits.slice(7)}`;
}

export const MaskedNumberField = forwardRef<HTMLInputElement, Props>(
  function MaskedNumberField({ onChange, value, ...props }, ref) {
    const rawValue = typeof value === 'string' ? value : '';

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      const digits = e.target.value.replace(/\D/g, '').slice(0, MAX_LENGTH);

      if (!ALLOW_PATTERN.test(digits)) return;

      onChange?.(digits);
    };

    return (
      <TextField
        {...props}
        ref={ref}
        type="tel"
        value={formatPhoneNumber(rawValue)}
        onChange={handleChange}
      />
    );
  },
);
